import { defineMessages } from 'react-intl';

export const navigationMessages = defineMessages({
  inventorization: {
    id: 'app.inventory.navigation.inventorization',
  },
  meters: {
    id: 'app.inventory.navigation.meters',
  },
  scan: {
    id: 'app.inventory.navigation.scan',
  },
  settings: {
    id: 'app.inventory.navigation.settings',
  },
  sync: {
    id: 'app.inventory.navigation.sync',
  },
  today: {
    id: 'app.inventory.navigation.today',
  },
});

export const messages = defineMessages({
  autoSyncFailed: {
    id: 'app.inventory.autoSync.failed',
  },
  autoSyncOff: {
    id: 'app.inventory.autoSync.off',
  },
  autoSyncOn: {
    id: 'app.inventory.autoSync.on',
  },
  autoSyncRunning: {
    id: 'app.inventory.autoSync.running',
  },
  shellChangeLocation: {
    id: 'app.inventory.shell.changeLocation',
  },
  shellNoLocation: {
    id: 'app.inventory.shell.noLocation',
  },
  shellPageMenu: {
    id: 'app.inventory.shell.pageMenu',
  },
  shellRefresh: {
    id: 'app.inventory.shell.refresh',
  },
  shellSettings: {
    id: 'app.inventory.shell.settings',
  },
});
